/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddOwnerDto } from '../../models/add-owner-dto';
import { AddOwnerResponse } from '../../models/add-owner-response';

export interface AddOwner$Params {
      body: AddOwnerDto
}

export function addOwner(http: HttpClient, rootUrl: string, params: AddOwner$Params, context?: HttpContext): Observable<StrictHttpResponse<AddOwnerResponse>> {
  const rb = new RequestBuilder(rootUrl, addOwner.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AddOwnerResponse>;
    })
  );
}

addOwner.PATH = '/api/v2/owner';
